import { IGbIndex, IEuropeanIndex } from '@/interfaces/benchmarks/index/IIndex.ts';

export interface IGbIndexLegacyPageSettings {
    customIndices: Record<string, IGbIndex>;
    allLegacyIndicesDeleted?: boolean;
}

export interface IEuropeanIndexLegacyPageSettings {
    customIndices: Record<string, Record<string, IEuropeanIndex>>;
}

export const DEFAULT_EUROPEAN_INDEX_SETTINGS: IEuropeanIndexLegacyPageSettings = {
    customIndices: {},
};

export const DEFAULT_GB_INDEX_SETTINGS: IGbIndexLegacyPageSettings = {
    customIndices: {},
    allLegacyIndicesDeleted: false,
};
